import React, { Component } from 'react';

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result'

/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as loadingActions } from '../../redux/ducks/loading'

/* Routes */
import { domainIsTenant as dit, S } from '../../routes/routes'

/* Json Editor */
import JsonEditor from '../../lib/components/JsonEditor';

/* Object Json */
import { isEmpty, isNone } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType, parse, stringify, stringifyFormatted, clean } from 'iotera-base/json';

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';

import { IoteraForm } from '../../lib/components/form';
import { SubViewHeader } from '../../lib/components/subHeader';
import { Button } from '@material-ui/core';
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';
import { getLayoutsFromDashboard } from '../../lib/position/react-grid-layout';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const ADD = "ADD";
const WKEY = "DASHBOARD_ADD_MANUAL";
let wSelector = buildWSelector(WKEY)
let wBoundAction = buildWBoundActions(WKEY)

function schema() {
  return {
    type: "object",
    required: ["key", "config"],
    properties: {
      key: { type: "string", title: "Component Key", maxLength: 30 },
      config: { type: "string", title: "Konfigurasi", minLength: 0 }
    }
  }
};

const uiSchema = {
  config: {
    "ui:widget": (props) => {
      return (
        <div style={{ padding: 1, border: '1px solid #CED4DA' }}>
          <JsonEditor {...props} />
        </div>
      )
    },
  }
};

class DashboardAdd extends Component {
  constructor(props) {
    super(props);
    const dashboardId = safeDeepGet(this, ['props', 'id']);
    this.state = {
      loading: true,
      dashboardId,
      formData: {}
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props;
    const _state = _this.state
    const { dashboardId } = _state;
    if (isEmpty(dashboardId)) {
      return;
    }
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    // Get dashboard
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: '/service/web/application/nav/get/id/' + dashboardId },
        wcallback: {
          started: function (id) {
            _props.showLoading();
          },
          finished: function (id, result) {
            if (result['code'] === 200) {
            } else {
              _this.setState({ loading: false })
            }
            _props.hideLoading();
          }
        },
        wreducer: {
          rparse: function (id, result, rpayload) {
            let item = {};
            let dashboard = rpayload;
            let parent = safeDeepGetWithType(dashboard, ['parent'], '');
            let path = safeDeepGetWithType(dashboard, ['path'], '');
            item.label = safeDeepGetWithType(dashboard, ['label'], '');
            let desc = safeDeepGetWithType(dashboard, ['desc'], '');
            if (desc === '') {
              desc = null
            }
            item.desc = desc;
            item.config = '{}';
            item.dashboard = safeDeepGetWithType(dashboard, ['conf_dashboard'], {});
            if (parent !== '') {
              item.parent = parent;
            }
            clean(item)
            _this.setState({ loading: false, path })
            return item;
          }
        }
      }
    );

    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/nav/edit"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _props.history.push('..' + S + _this.state.path)
                  _props.showSingleNotification({ message: 'Add Dashboard Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Add Dashboard Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { dashboardId } = _state
    if (isEmpty(dashboardId)) {
      return;
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }

  handleChange(event) {
    this.setState({ formData: event.formData })
  }

  handleSubmit() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let dashboard = safeDeepGet(_state, ['formData'])
    if (isEmpty(dashboard)) {
      dashboard = safeDeepGet(_props, ['item'])
    }
    const key = safeDeepGet(dashboard, ['key']);
    let dashboardComponent = safeDeepGet(dashboard, ['config']);
    dashboardComponent = parse(dashboardComponent)
    if (isEmpty(key)) {
      _props.showSingleNotification({ message: 'Key tidak boleh kosong', level: 'warning' });
      return;
    }
    if (isNone(dashboardComponent)) {
      dashboard['config'] = stringify(dashboardComponent)
      _props.showSingleNotification({ message: 'Konfigurasi harus dalam bentuk JSON yang benar', level: 'warning' });
      _this.setState({ formData: dashboard })
      return;
    }
    dashboard['config'] = stringifyFormatted(dashboardComponent)
    _this.setState({ formData: dashboard })
    let newDash = {
      [key]: dashboardComponent
    }
    const currDashboard = safeDeepGetWithType(_props, ['item', 'dashboard'], {});
    if (key in safeDeepGetWithType(currDashboard, ['dashboard'], {})) {
      ioteraConfirmAlert(
        'Component key sudah terdaftar',
        <span>Apakah anda yakin untuk tetap menyimpan dengan component key saat ini?
          <br />
          (dashboard dengan component key yang sama akan tergantikan)
        </span>,
        null,
        () => this.executeSave(newDash, currDashboard),
        null,
        null
      )
    } else {
      _this.executeSave(newDash, currDashboard)
    }
  }

  executeSave = (_new, curr) => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const id = safeDeepGet(_state, ['dashboardId']);
    let currDash = safeDeepGetWithType(curr, ['dashboard'], {})
    let finalDash = { ...currDash, ..._new }
    curr.dashboard = finalDash;
    const layout = getLayoutsFromDashboard(finalDash)
    localStorage.setItem(id, stringify(layout));
    _props.wSingleRequestCall({
      id: ADD,
      body: {
        id,
        conf_dashboard: curr
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { formData, loading } = _state
    let dataToShow = {}
    if (!isEmpty(formData)) {
      dataToShow = formData
    }
    else {
      let item = safeDeepGetWithType(_props, ['item'], {});
      if (!isEmpty(item)) {
        dataToShow = item;
      }
    }
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    if (!isEmpty(dataToShow)) {
      return (
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title='Add Dashboard' subTitle='Formulir Add Dashboard' />
            <div className="io-container mt-12">
              <IoteraForm
                schema={schema()}
                uiSchema={uiSchema}
                formData={dataToShow}
                onChange={_this.handleChange}
                onSubmit={_this.handleSubmit}
              >
                <div className="button-right">
                  <Button variant="outlined" type="button" size="large" style={{ minWidth: '0%' }}
                    onClick={() => _props.history.goBack()} >Batal</Button>
                  <Button variant="contained" size="large" color="primary" type="submit"
                    style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</Button>
                </div>
              </IoteraForm>
            </div>
          </div>
        </Loader>
      );
    } else {
      return (
        <div className="view">
          <SubViewHeader title='Add Dashboard' subTitle='Formulir Add Dashboard' />
          <div className="view-content-dashboard" />
        </div>
      );
    }
  }
}

const mapStateToProps = function (state) {
  return {
    item: wSelector.getSoleInitMappedRPayload(state)
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundAction(dispatch),
    ...bindActionCreators(notificationActions, dispatch),
    ...bindActionCreators(loadingActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardAdd));